import { CategoryList } from './CategoryList';

const IEMSections = () => {
    // Sets activeCategory to Model on first load/reload.
    // This will need to change in the future but will leave
    // it for the time being.

    return (
        // <Box>
        <CategoryList />
        // </Box>
    );
};

export default IEMSections;
